<template>
  <div id="PreviewSmsMessage">
    <div class="screen-header">
      {{phoneNumber || '1 (800) 555-5555' }}
    </div>
    <div class="message-wrapper">
      <div class="message-text" v-html="messageHtml || $t('Message')"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PreviewSmsMessage',
  props: {
    message: String,
    phoneNumber: String
  },
  computed: {
    messageHtml() {
      let str = this.message
      if (str) {
        str = str.replace('https://s.fplr.co/xxxxxxxxxx', '<span class="link">https://s.fplr.co/xxxxxxxxxx</span>')
      }
      return str
    }
  }

}
</script>

<style lang="scss">
#PreviewSmsMessage {
  
  width: 315px;
  position: relative;
  border-radius: 2px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  border: 1px solid #E4E4E4;// rgba(204, 204, 204, .2);

  .screen-header {
    line-height: 26px;
    background: #EAEAEA;
    text-align: center;
    font-size: 12px;
    border: 1px solid #E4E4E4;
    border-bottom: 1px solid #cfcaca;
    margin: -1px;
    border-top-left-radius: 0.5px;
    border-top-right-radius: 0.5px;
  }

  .message-wrapper {
    max-width: 250px;
    position: relative;
    display: inline-block;
    font-family: 'Lucida Grande', 'Lucida Sans Unicode', sans-serif;
    background: #EAEAEA;
    margin: 15px 0 15px 9px;
    border-radius: 15px;

    .message-text {
      max-width: 225px;
      margin: 3px 9px 3px 9px;
      font-size: 12px;
      text-align: left;
      overflow: hidden;
      white-space: pre-wrap;
      overflow-wrap: break-word;
    }
  }
  .message-wrapper::before {
    content: '';
    position: absolute;
    left: -6px;
    bottom: 0px;
    width: 0;
    height: 0;
    border-bottom: 2px solid transparent;
    border-top: 14px solid transparent;
    border-right: 12px solid #EAEAEA;
    transform: rotate(-30deg);
  }

}
</style>
